export default __webpack_public_path__ + "static/media/swapping.ebfe6c83.jpg";